import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { colors } from '@seeqdev/qomponents/colors.stylex';

interface ClearAllFiltersButtonProps {
  onClear: () => void;
}

export const ClearAllFiltersButton = ({ onClear }: ClearAllFiltersButtonProps) => {
  const { t } = useTranslation();

  return (
    <span data-testid="clearAllFiltersButton" {...stylex.props(clearFiltersStyles.clearFilters)} onClick={onClear}>
      <span>{t('HOME_SCREEN.CLEAR_ALL')} &times;</span>
    </span>
  );
};

export const clearFiltersStyles = stylex.create({
  clearFilters: {
    cursor: 'pointer',
    marginLeft: 10,
    fontStyle: 'italic',
    color: {
      'default': colors.legacyToolsLink,
      ':hover': colors.legacyToolsPrimary,
      ':focus': colors.legacyToolsPrimary,
      ':active': colors.legacyToolsPrimary,
    },
    textDecoration: { 'default': 'none', ':hover': 'underline' },
  },
});
